// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChecksIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m18.701 10.714-11.2 11a1 1 0 0 1-1.402 0L1.299 17A1 1 0 1 1 2.7 15.574L6.8 19.599 17.3 9.286a1 1 0 0 1 1.402 1.428Zm12.013-1.415a1 1 0 0 0-1.415-.013L18.799 19.6l-2.354-2.313a1 1 0 1 0-1.401 1.428l3.053 3a1 1 0 0 0 1.403 0l11.2-11a1.002 1.002 0 0 0 .014-1.415Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
